import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Header } from "../components/Header";
import { api, errMsg } from "../lib/api";
import { usePrivatePage } from "../lib/seo";

export default function Review() {
  usePrivatePage("Rate your shield");
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ rating: 0, text: "", display_name: "", location: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/reviews/t/${token}`).then((r) => { setD(r.data); setSent(r.data.done); setF((x) => ({ ...x, display_name: r.data.first_name, location: r.data.county })); })
      .catch((e) => setErr(errMsg(e)));
  }, [token]);
  const submit = (e) => {
    e.preventDefault();
    if (!f.rating) return toast.error("Tap a star to rate your shield");
    setBusy(true);
    api.post(`/reviews/t/${token}`, f).then(() => setSent(true)).catch((x) => toast.error(errMsg(x))).finally(() => setBusy(false));
  };
  const input = "w-full border-2 border-slate-900 px-3 py-2 text-base";
  return (
    <div className="min-h-screen">
      <Header onNew={() => { window.location.href = "/design"; }} />
      <main className="mx-auto max-w-lg px-4 py-10">
        <div className="border-2 border-slate-900 bg-white p-6 shadow-[6px_6px_0_0_#0f172a]" data-testid="review-card">
          {err ? <p className="font-bold" data-testid="review-error">{err}</p> : !d ? <p>Loading…</p> : sent ? (
            <div data-testid="review-thanks"><h1 className="font-display text-3xl font-black uppercase">Thank you!</h1><p className="mt-2 text-slate-600">Your review helps other families and clubs find us.</p></div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <h1 className="font-display text-3xl font-black uppercase leading-none">How's your shield?</h1>
              <p className="text-sm text-slate-600">Order {d.order_number}</p>
              <div className="flex gap-1" role="radiogroup" aria-label="Rating">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} type="button" role="radio" aria-checked={f.rating === n} aria-label={`${n} star${n > 1 ? "s" : ""}`} onClick={() => setF({ ...f, rating: n })} data-testid={`review-star-${n}`}>
                    <Star className={`h-10 w-10 transition-transform hover:scale-110 ${n <= f.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
                  </button>
                ))}
              </div>
              <textarea value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} rows={4} maxLength={1200} placeholder="What did you think? (optional)" className={input} data-testid="review-text" />
              <div className="grid grid-cols-2 gap-2">
                <input value={f.display_name} onChange={(e) => setF({ ...f, display_name: e.target.value })} maxLength={40} required placeholder="Your name" className={input} data-testid="review-name" />
                <input value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} maxLength={40} placeholder="County (optional)" className={input} data-testid="review-location" />
              </div>
              <p className="text-xs text-slate-500">Your name and county may be shown with your review on sportsshields.ie.</p>
              <button type="submit" disabled={busy} className="btn-blaze w-full py-3" data-testid="review-submit">{busy ? "Sending…" : "Send review"}</button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
